;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    var mySwiper = new Swiper('.swiper-container', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination'
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar'
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
    $('.swiper-button-play').on('click', function () {
      mySwiper.autoplay.start();
      $(this).css('visibility', 'hidden');
      $('.swiper-button-pause').css('visibility', 'visible');
    });
    $('.swiper-button-pause').on('click', function () {
      mySwiper.autoplay.stop();
      $(this).css('visibility', 'hidden');
      $('.swiper-button-play').css('visibility', 'visible');
    });
  });
  $();
})(window, document, jQuery);
/*!
 * classie - class helper functions
 * from bonzo https://github.com/ded/bonzo
 *
 * classie.has( elem, 'my-class' ) -> true/false
 * classie.add( elem, 'my-new-class' )
 * classie.remove( elem, 'my-unwanted-class' )
 * classie.toggle( elem, 'my-class' )
 */

/*jshint browser: true, strict: true, undef: true */

/*global define: false */
(function (window) {
  'use strict'; // class helper functions from bonzo https://github.com/ded/bonzo

  function classReg(className) {
    return new RegExp("(^|\\s+)" + className + "(\\s+|$)");
  } // classList support for class management
  // altho to be fair, the api sucks because it won't accept multiple classes at once


  var hasClass, addClass, removeClass;

  if ('classList' in document.documentElement) {
    hasClass = function (elem, c) {
      return elem.classList.contains(c);
    };

    addClass = function (elem, c) {
      elem.classList.add(c);
    };

    removeClass = function (elem, c) {
      elem.classList.remove(c);
    };
  } else {
    hasClass = function (elem, c) {
      return classReg(c).test(elem.className);
    };

    addClass = function (elem, c) {
      if (!hasClass(elem, c)) {
        elem.className = elem.className + ' ' + c;
      }
    };

    removeClass = function (elem, c) {
      elem.className = elem.className.replace(classReg(c), ' ');
    };
  }

  function toggleClass(elem, c) {
    var fn = hasClass(elem, c) ? removeClass : addClass;
    fn(elem, c);
  }

  var classie = {
    // full names
    hasClass: hasClass,
    addClass: addClass,
    removeClass: removeClass,
    toggleClass: toggleClass,
    // short names
    has: hasClass,
    add: addClass,
    remove: removeClass,
    toggle: toggleClass
  }; // transport

  if (typeof define === 'function' && define.amd) {
    // AMD
    define(classie);
  } else {
    // browser global
    window.classie = classie;
  }
})(window);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    const $accordion = $('.accordion'),
          $collapse = $accordion.find('.collapse');

    const modify = function (open) {
      const CLASS_NAME = 'js-accordion-open';
      const $accordion = $(this).closest('.accordion');
      return open ? $accordion.addClass(CLASS_NAME) : $accordion.removeClass(CLASS_NAME);
    }; // The collapsible content is about to be shown.


    $collapse.on('show.bs.collapse', function () {
      modify.call(this, true);
    }); // The collapsible content is now fully shown.

    $collapse.on('shown.bs.collapse', function () {
      const $accordionBody = $(this).find('.accordion-body');
      setTimeout(() => $accordionBody.focus(), 100);
    }); // The collapsible content is about to be hidden.

    $collapse.on('hide.bs.collapse', function () {
      modify.call(this);
    }); // The collapsible content is now hidden.

    $collapse.on('hidden.bs.collapse', function () {
      const $button = $(this);

      if (!$button.is(':focus')) {
        setTimeout(() => {
          $button.focus();
        }, 100);
      }
    });
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    const menuTrigger = $("#footerMenuTrigger");
    const navArrow = $("#navArrow");
    menuTrigger.on('click', function () {
      $("#footer_hiddenMenu").slideToggle("slow", function () {
        navArrow[0].classList.toggle('navigate_arrow--active');
      });
    });
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {});
  $(document).on("gform_post_render", function (e, form_id) {
    // code to run upon successful form submission
    contactFormHandler();
  });

  function contactFormHandler() {
    // trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
    if (!String.prototype.trim) {
      (function () {
        // Make sure we trim BOM and NBSP
        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

        String.prototype.trim = function () {
          return this.replace(rtrim, '');
        };
      })();
    }

    [].slice.call(document.querySelectorAll('.contact-form .input__field input')).forEach(function (inputEl) {
      // in case the input is already filled..
      if (inputEl.value.trim() !== '') {
        classie.add(inputEl.parentNode, 'input--filled');
      } // events:


      inputEl.addEventListener('focus', onInputFocus);
      inputEl.addEventListener('blur', onInputBlur);
    });

    function onInputFocus(ev) {
      classie.add(ev.target.parentNode, 'input--filled'); // add class to in label

      const $label = $(ev.target).closest('.input__field').find('label');
      $label.addClass('go');
    }

    function onInputBlur(ev) {
      if (ev.target.value.trim() === '') {
        classie.remove(ev.target.parentNode, 'input--filled'); //remove class from label

        const $label = $(ev.target).closest('.input__field').find('label');
        $label.removeClass('go');
      }
    }
  }
})(window, document, jQuery);
"use strict";

function getTop() {
  return jQuery(window).scrollTop();
}

function isIE11() {
  return !!window.MSInputMethodContext && !!document.documentMode;
}

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function scroll_to(element, distance = 10) {
  const $element = jQuery(element);
  const $site_navbar = jQuery('#site_navbar');

  if ($element.length) {
    const scrollTop = $element.first().offset().top - ($site_navbar.outerHeight() + window.parseInt(distance));
    jQuery('html, body').animate({
      scrollTop
    }, {
      duration: 1000,
      easing: 'easeInOutExpo'
    });
  }
}

class Comp_Factory {
  constructor($, CLASS_NAME) {
    this.$ = $;
    this.CLASS_NAME = CLASS_NAME;
  }

  open() {
    return this.$.addClass(this.CLASS_NAME);
  }

  close() {
    return this.$.removeClass(this.CLASS_NAME);
  }

  toggle() {
    return this.$.toggleClass(this.CLASS_NAME);
  }

  is_open() {
    return this.$.hasClass(this.CLASS_NAME);
  }

}

;

(function (window, document, $) {
  $.fn.doSlickSlide = function (direction) {
    var self = $(this),
        slickSection = self.closest('.slick-section');
    if (slickSection.length > 0) slickSection.find('.slick-slider').slick(direction);
    return this;
  };

  $('.slick-next').on('click', function () {
    $(this).doSlickSlide('slickNext');
  });
  $('.slick-prev').on('click', function () {
    $(this).doSlickSlide('slickPrev');
  });
  $.easing['jswing'] = $.easing['swing'];
  $.extend(jQuery.easing, {
    easeInOutExpo: function (x, t, b, c, d) {
      if (t == 0) return b;
      if (t == d) return b + c;
      if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    const menuTrigger = $("#header__navigator");
    const hiddenMenu = $("#header__hiddenMenu");
    const pageHeight = $(document).height();
    hiddenMenu.css('height', `${pageHeight}px`);
    menuTrigger.on('click', function () {
      $(this).toggleClass('active');
      $(this).toggleClass('not-active');
      $(window).innerWidth() <= 767 && $('body').toggleClass('no-scroll');
      hiddenMenu.slideToggle("slow", function () {});
    });
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    $(".home #header").addClass('header-sticky'); // fade away text

    const slideshow = $("#videoContainer__slideshow-container");
    $(window).scroll(function (event) {
      let scrollPos = $(window).scrollTop();
      slideshow.css('opacity', (400 - scrollPos) / 400);
    });
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict"; // main hero classes

  setTimeout(() => {
    const $el = document.querySelector('.hero__content ');
    $el && $el.classList.add('hero__content--open');
  }, 500);
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    $('.none').each(function () {// const $height = $(this).height();
      //$(this).css('height', $height);
      // $(this).hide();
    });
    $(".accordion button").on('click', function () {
      $(this).next().slideToggle(300);
      $(this).find('svg').toggleClass('lawyer__svg--active');
    });
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    var lock = false;
    var slideIndex = 0;
    $('.mySlides').eq(slideIndex).fadeIn(300);
    let sliderPaused = false;
    const prev = document.getElementById('prev__home');
    const next = document.getElementById('next__home');
    let refreshIntervalId = setInterval(() => {
      if (sliderPaused) return;
      plusSlides(1);
    }, 7000);
    if (prev) prev.addEventListener('click', () => {
      resetSetInterval();
      plusSlides(-1);
      console.log('click');
    });
    if (next) next.addEventListener('click', () => {
      resetSetInterval();
      plusSlides(1);
    });

    function resetSetInterval() {
      clearInterval(refreshIntervalId);
      refreshIntervalId = setInterval(() => {
        if (sliderPaused) return;
        plusSlides(1);
      }, 7000);
    } // Next/previous controls


    function plusSlides(n) {
      showSlides(slideIndex += n);
    }

    function showSlides(n) {
      if (!lock) {
        lock = true;
        var slides = $('.mySlides'); // 

        $(this).toggleClass('active'); // 

        $('.mySlides:visible').fadeOut(300, () => {
          $(slides[Math.abs(n % slides.length)]).fadeIn(300);
          lock = false;
        });
      }
    }

    const vid = document.getElementById('homeVideo');
    let isPaused = false;
    $('#pauseVideo').on('click', function () {
      sliderPaused = !sliderPaused; // $('#homeVideo').pause();

      if (isPaused) {
        vid.play();
        $('#pauseVideo').html('<svg class="videoContainer__svg" xmlns="http://www.w3.org/2000/svg" width="100pt" height="100pt" viewBox="0 0 100 100"><path d="M50 0C36.738 0 24.02 5.27 14.645 14.645S0 36.739 0 50s5.27 25.98 14.645 35.355S36.739 100 50 100s25.98-5.27 35.355-14.645S100 63.261 100 50s-5.27-25.98-14.645-35.355S63.261 0 50 0zm0 94.445c-11.789 0-23.094-4.684-31.426-13.02-8.336-8.332-13.02-19.637-13.02-31.426s4.684-23.094 13.02-31.426C26.906 10.237 38.211 5.553 50 5.553s23.094 4.684 31.426 13.02c8.336 8.332 13.02 19.637 13.02 31.426-.016 11.785-4.7 23.082-13.031 31.414-8.332 8.332-19.629 13.016-31.414 13.031z" /><path d="M41.668 30.555c-1.535 0-2.777 1.246-2.777 2.777v33.336c0 1.531 1.242 2.778 2.777 2.778 1.531 0 2.777-1.247 2.777-2.778V33.332c0-.734-.293-1.441-.816-1.96-.52-.524-1.227-.817-1.961-.817zM58.332 30.555c-1.531 0-2.777 1.246-2.777 2.777v33.336c0 1.531 1.246 2.778 2.777 2.778 1.535 0 2.777-1.247 2.777-2.778V33.332c0-.734-.289-1.441-.812-1.96-.52-.524-1.227-.817-1.965-.817z" /></svg>');
        isPaused = false;
      } else {
        vid.pause();
        $('#pauseVideo').html("<svg class='videoContainer__svg' version='1.1' xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'><path d='M256 0c-141.385 0-256 114.615-256 256s114.615 256 256 256 256-114.615 256-256-114.615-256-256-256zM256 464c-114.875 0-208-93.125-208-208s93.125-208 208-208 208 93.125 208 208-93.125 208-208 208zM192 144l192 112-192 112z'></path></svg>");
        isPaused = true;
      }
    });
  });
})(window, document, jQuery);